import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ExpenseHeadMaster } from "../models/expenseheadmaster"; 
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core'
import { map } from "rxjs/operators";
import { HttpClient, JsonpClientBackend } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ExpenseHeadService {
  apiEndpoint: string;
  baseApiUrl: any;
  apiUniqueId: string = 'expensehead/id/d32a6cc9-353b-4e23-90fb-3c410cd6fd7e/';

  constructor(private httpService: HttpWrapperService, private http: HttpClient,
    private configService: ConfigService
  ) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllExpenseHeads(filter: string, pagesize: number, pagenumber: number,filterType : number,filterData: number): Observable<Array<ExpenseHeadMaster>> { 
    return this.httpService.get(this.apiEndpoint + 'getAllExpenseHeads?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)+ '&filterType=' + (filterType ? filterType : 0)+ '&filterData=' + (filterData ? filterData : 0)).pipe(map((result: any) => {                         
      if (result.Success) {        
        return result.Data;
      } else {
        return [];
      }
    }));
  }
 
  viewExpenseHead(ExpenseHeadID?: string): Observable<Array<ExpenseHeadMaster>> {
    return this.httpService.get(this.apiEndpoint + 'viewExpenseHead/' + (ExpenseHeadID ? ExpenseHeadID : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  saveExpenseHead(locations: ExpenseHeadMaster): Observable<any> { 
    return this.httpService.post(this.apiEndpoint + 'saveExpenseHead/', locations).pipe(map((result: any) => {
      if (result.Success) { 
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteExpenseHead(ExpenseHeadID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + 'deleteExpenseHead/' + (ExpenseHeadID ? ExpenseHeadID : '00000000-0000-0000-0000-000000000000'), ExpenseHeadID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(ExpenseHeadName?: string,ExpenseHeadId?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + 'checkDuplication?ExpenseHeadName=' + (ExpenseHeadName ? ExpenseHeadName : '')+ '&ExpenseHeadId=' + (ExpenseHeadId ? ExpenseHeadId : '00000000-0000-0000-0000-000000000000')).pipe(map((result: any) => {
        return result; 
    }));
  }
}
